import { createSlice } from '@reduxjs/toolkit';
import { fetchCommunityByCommunityId} from '../CommunityAPI/communityApi';

const communityByIdSlice = createSlice({
  name: 'communityById',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle fetchCommunityData cases
      .addCase(fetchCommunityByCommunityId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCommunityByCommunityId.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchCommunityByCommunityId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
  },
});

export default communityByIdSlice.reducer;
